<template>
  <div>

    <div v-if="loading">
      <v-progress-linear color="primary" indeterminate></v-progress-linear>
    </div>

    <div v-else>
      <v-layout wrap>
        <v-flex lg8 md8 sm12 xs12>
        </v-flex>
        <v-flex lg4 md4 sm12 xs12>
          <v-text-field :label="$t('data-table.search')" @change="search($event)"></v-text-field>
        </v-flex>
      </v-layout>

      <v-data-table :headers=" headers" :items="calednarHistory" :pagination.sync="pagination" class="elevation-10">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.scheduledAt }}</td>
          <td>{{ props.item.created_by_full_name }}</td>
          <td>{{ props.item.updated_by_full_name }}</td>
          <td>{{ props.item.updated_at }}</td>
        </template>
      </v-data-table>
    </div>

  </div>
</template>

<script>
import ItemForm from "@/components/storage/ItemForm"
import New from "@/components/storage/New"
import Messenger from "@/plugins/Messenger"

export default {
  name: "History",
  components: {New, ItemForm},
  props: ['users', 'calendarId'],
  data() {
    return {
      calednarHistory: [],
      allCalednarHistory: [],
      loading: true,
      products: [],
      headers: [
        {
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('calendar.history.name'),
          value: 'title'
        },
        {
          text: this.$t('calendar.history.description'),
          value: 'description'
        },
        {
          text: this.$t('calendar.history.scheduled_at'),
          value: 'scheduledAt'
        },
        {
          text: this.$t('calendar.history.created_by'),
          value: 'created_by'
        },
        {
          text: this.$t('calendar.history.modified_by'),
          value: 'modified_by'
        },
        {
          text: this.$t('calendar.history.updated_at'),
          value: 'updated_at'
        },
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25 // -1 for All",
      }
    }
  },
  watch: {
    calendarId: function (newVal) {
      this.loading = true
      this.$http.get(`calendar/${newVal}/history`).then(data => {
        this.calednarHistory = data.data.map(this.expandCalendarHistory)
        this.allCalednarHistory = this.calednarHistory.map(el => el)
        this.loading = false
      }).catch(() => {
        Messenger.emitError(this.$t('calendar.history.download_error'))
      })
    }
  },
  methods: {
    getUser(id) {
      let user = this.users ? this.users.find(el => el.id == id) : false
      if (user) {
        return user.name + " " + user.surname
      }
      return ""
    },
    search(text) {
      if (text == "") {
        this.calednarHistory = this.allCalednarHistory
      }

      text = text.toLowerCase()
      this.calednarHistory = this.allCalednarHistory.filter(history =>
        history.created_by_full_name.toLowerCase().includes(text) || history.updated_by_full_name.toLowerCase().includes(text)
          || history.title.toLowerCase().includes(text) || history.description.toLowerCase().includes(text)
          || history.scheduledAt.includes(text) || history.updated_at.includes(text)
      )
    },
    expandCalendarHistory(ch) {
      ch.created_by_full_name = this.getUser(ch.created_by)
      ch.updated_by_full_name = this.getUser(ch.updated_by)
      return ch
    }
  },
}
</script>

<style scoped>

</style>